// Turns a pasted plain-text bio into blocks: ALL-CAPS lines -> headings, "•"/"-"/"*" lines -> bullet items, the rest -> paragraphs.
const CAPS_HEADING = /^(?=.*[A-Z]{3})[A-Z0-9 &/,'’().:-]{4,80}$/;
const BULLET = /^\s*(?:[•●▪◦*]|-|–)\s*/;

export function normalisePasted(text) {
  return (text || "")
    .replace(/\r/g, "")
    .replace(/\s*[•●▪◦]\s*/g, "\n• ")
    .replace(/([a-z0-9.)\]])([A-Z][A-Z &/]{3,}[A-Z])(?=[-–]|\n|$|[A-Z][a-z])/g, "$1\n$2\n")
    .replace(/(^|\n)([A-Z][A-Z &/]{3,}[A-Z])\s*[-–]\s*/g, "$1$2\n- ")
    .replace(/([.)])\s*[-–](?=[A-Z])/g, "$1\n- ")
    .replace(/\b([A-Z]{2,})[-–](?=[A-Z][a-z])/g, "$1\n- ");
}

export function structureText(text) {
  const blocks = [];
  normalisePasted(text).split("\n").map((l) => l.trim()).filter((l) => l && l.replace(BULLET, "").trim()).forEach((line) => {
    if (BULLET.test(line) && line.replace(BULLET, "").trim()) {
      const item = line.replace(BULLET, "").trim();
      const last = blocks[blocks.length - 1];
      if (last?.type === "ul") last.items.push(item); else blocks.push({ type: "ul", items: [item] });
    } else if (CAPS_HEADING.test(line) && line === line.toUpperCase()) {
      blocks.push({ type: "h3", text: line.charAt(0) + line.slice(1).toLowerCase() });
    } else {
      blocks.push({ type: "p", text: line });
    }
  });
  return blocks;
}

export const looksStructured = (text) => /\n|[•●▪◦]|(^|[\s.)])[A-Z][A-Z &/]{6,}[A-Z]/.test(text || "");

export const htmlToText = (html) => (html || "").replace(/<br\s*\/?>/gi, "\n").replace(/<\/(p|div|li|h\d)>/gi, "\n").replace(/<li[^>]*>/gi, "• ")
  .replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#39;|&apos;/g, "'").replace(/&quot;/g, '"');
